import type { Playbook, Workspace } from '@carboncopyco/types';
import { PlaybookModal } from './PlaybookModal';
import { PlaybookModalProvider } from './PlaybookModalContext';

type CreatePlaybookModalProps = {
  workspaceId: string;
  onClose: () => void;
  onSuccess?: (playbookId: Playbook['id'], workspace?: Workspace['id']) => void;
};

export const CreatePlaybookModal = ({
  workspaceId,
  onClose,
  onSuccess,
}: CreatePlaybookModalProps) => {
  return (
    <PlaybookModalProvider workspaceId={workspaceId}>
      <PlaybookModal
        onClose={onClose}
        onSuccess={onSuccess}
      />
    </PlaybookModalProvider>
  );
};
